import React from 'react'

export const Hr = ({ isMobile }) => {
  return !isMobile ? <hr /> : <></>
}
